export const iconFontAwesomeHalloweenHatWizard = (
	<i className="fa-solid fa-hat-wizard"></i>
);
